// Shared diagnostics for server routes and browser transcription sessions.
// Never pass audio, transcript text, credentials or temporary tokens here.
export function logAssembly(level, event, payload = {}) {
  const logger = level === "error" ? console.error : level === "warn" ? console.warn : console.info;
  logger(`[assembly] ${event}`, { ...payload, event, service: "assembly" });
}

export function createAssemblyRequestId() {
  return crypto.randomUUID();
}

// The only fields a browser diagnostic may carry, top level and in `details`.
// Audio, transcript text, credentials and tokens have no key here, so they are
// dropped before the payload leaves the browser; /api/voice-agent/log applies
// the same lists to whatever reaches it.
const CLIENT_LOG_KEYS = [
  "event", "origin", "page", "requestId", "tokenRequestId", "simulationType", "scenarioId",
  "personaId", "recordingMode", "language", "connectionReady", "connecting", "details",
];
const CLIENT_LOG_DETAIL_KEYS = [
  "name", "message", "code", "generation", "failures", "assemblyError", "tokenCircuitOpen",
  "isSimulationStarted", "microphoneOpen", "msSinceMicOpened", "recordingMode", "microphoneDeviceName",
  // /support/connection-check: the verdict code and each step's outcome.
  "verdict", "checks",
];

function pickKeys(value, keys) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  return Object.fromEntries(keys.filter(key => Object.hasOwn(value, key)).map(key => [key, value[key]]));
}

export function pickClientLogFields(payload) {
  const fields = pickKeys(payload, CLIENT_LOG_KEYS);
  if ("details" in fields) fields.details = pickKeys(fields.details, CLIENT_LOG_DETAIL_KEYS);
  return fields;
}

export function postAssemblyClientLog(payload) {
  if (typeof window === "undefined") return;
  try {
    fetch("/api/voice-agent/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(pickClientLogFields({ page: window.location.pathname, ...payload })),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Diagnostics cannot interrupt audio or session teardown.
  }
}
